import cx from 'classnames';
import PartUnitPrice from '../part-unit-price';
import DiscountPrice from 'components/price/discount-price';
import styles from '../part-price.module.scss';
import Price from 'components/price';

export const PartPriceDesktop = ({
  showDiscountSection,
  showUnitPrice,
  saudiCurrencySymbol,
  totalPrice,
  currencyCode,
  unitPrice,
  price,
  isRTL,
  currencyLdFeatureFlag
}) => {
  return (
    <div className="d-none d-lg-block">
      <div className="d-flex flex-row">
        <Price
          amount={totalPrice.toString()}
          currency={currencyCode}
          isRTL={isRTL}
          currencyLdFeatureFlag={currencyLdFeatureFlag}
          customStyles={{
            container: cx(styles['price--part'], 'mb-0'),
            price: saudiCurrencySymbol ? 'px-1' : 'cat-u-theme-typography-title'
          }}
          customTestIdPrefix={'total-price-desktop'}
        />
      </div>
      {showUnitPrice && (
        <PartUnitPrice
          unitPrice={unitPrice}
          currencyCode={currencyCode}
          isRTL={isRTL}
          currencyLdFeatureFlag={currencyLdFeatureFlag}
        />
      )}
      {showDiscountSection && (
        <DiscountPrice
          price={price}
          isProductOverview={false}
          currency={currencyCode}
          isRTL={isRTL}
          currencyLdFeatureFlag={currencyLdFeatureFlag}
        />
      )}
    </div>
  );
};
